"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentApp = exports.getApiKey = exports.getAppName = void 0;
var tslib_1 = require("tslib");
var const_1 = require("./const");
var ua_1 = (0, tslib_1.__importDefault)(require("@douban/rexxar-common/es/assets/js/ua"));
function getAppName() {
    if (!ua_1.default.isFrodo()) {
        return const_1.SUPPORT_APP.Web_H5;
    }
    if (ua_1.default.isAndroid()) {
        return const_1.SUPPORT_APP.Frodo_Android_H5;
    }
    else if (ua_1.default.isIOS()) {
        return const_1.SUPPORT_APP.Frodo_iOS_H5;
    }
    return const_1.SUPPORT_APP.Web_H5;
}
exports.getAppName = getAppName;
function getApiKey() {
    if (!ua_1.default.isFrodo()) {
        return const_1.SUPPOR_API_KEY.Web_H5;
    }
    if (ua_1.default.isAndroid()) {
        return const_1.SUPPOR_API_KEY.Frodo_Android_H5;
    }
    else if (ua_1.default.isIOS()) {
        return const_1.SUPPOR_API_KEY.Frodo_iOS_H5;
    }
    return const_1.SUPPOR_API_KEY.Web_H5;
}
exports.getApiKey = getApiKey;
// android 会把 getDeviceInfo 和 getAppInfo 放到 current_app 下面
// iOS 则不会（但是 iOS 仍然会存在 current_app 这个全局变量）
// 所以这里加个判断，如果当前环境中有 current_app，优先使用 current_app
// 但是当有要求获取 current_app 中某个 property, 但是 current_app 中不存在时，则返回 g
/**
 * 获取 current app
 * @param g 当前 global
 * @param property 要检查是否存在的方法名
 * @returns
 */
function getCurrentApp(g, property) {
    if (g.current_app) {
        // 当前 current_app 中没有 property 时，要返回 window
        if (property && !g.current_app[property]) {
            return g;
        }
        return g.current_app;
    }
    return g;
}
exports.getCurrentApp = getCurrentApp;
//# sourceMappingURL=utils.js.map